module.exports = __webpack_public_path__ + "static/media/boy_with_dog.be8f25b2.gif";